<div class="wrapper">
<div class="wrap">
  <div class="intro">
    <div class="welcome">   
      <p id="headline" i18n> Welcome to the St.Gabriel Ethiopian Orthodox Church Website</p>
      <div class="line" i18n></div>
      <p id="history" i18n><b>HISTORY</b></p>
      <div class="paragraph-container">
        <p id="paragraph" i18n> The Orthodox church is the ancient christian church that traces it foundation back to 
          our Lord Jesus Christ and His Tweleve Apostles. The church has continued has pereserved the apostolic 
           doctrine and tradition, worship, and structure. The orthodox church maintains that the 
           church is the living Body of Jesus Christ.  
           <br><br>
           The Ethiopian Tewahedo Orthodox Church is among the Oriental Orthodox churches 
           which are referred to as "Non-Chalcedonian", and, sometimes by outsiders as "monophysite"
            (meaning "One Single Nature", in reference to Christ). The Ethiopian Church claims its earliest origins
            from the royal official said to have been baptized by Philip the Evangelist (Acts 8:27).
          </p>
      </div>
      <form action="https://www.paypal.com/donate" method="post" target="_top" style="padding-top:10px;">
        <div class="donate-container">
          <input type="hidden" name="hosted_button_id" value="ZL3HPTJGV38PU" />
          <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal button" />
          <img alt="" border="0" src="https://www.paypal.com/en_US/i/scr/pixel.gif" width="1" height="1" />
        </div> 
       </form>
    </div>
  <div class="image-intro">
      <div class="img-container">
        <img src="./assets/Kidus_Gabriel.png" />
        <p i18n>"እኔ በእግዚአብሔር ፊት የምቆመው ገብርኤል ነኝ" ሉቃስ 1 ፣ 19 </p> 
      </div>
  </div>
</div> 

<div class="services">
  <div class="fb-header service-header">
    <p class="fb-header-text "> <b i18n>Announcement</b></p>
    <div class="line"></div>
  </div>
  <div class="service-container">
    <div class="service-list">
     <h3 style="margin-top:5px; padding:5px;" i18n>ጾመ ፍልሰታ ሳምንታት <br>
      የአገልግሎት ሰዐታት<br>
      </h3>
     <div class="service-details">
        <div class="service-details-list two-fifty-width-pixel">
          <ul>
            <li i18n>
              ሰኞ - አርብ <br>
              <b>ፀበል ጥምቀት :</b> 8 AM - 10 AM <br>
              <b>ቅዳሴ :</b> 12 PM - 2:30 PM
            </li>
            <li i18n>
              ቅዳሜና እሁድ <br>
             <b>ቅዳሴ :</b> 6:30 AM - 9:30 AM <br>
             <b>ፀበል ጥምቀት</b> ከቅዳሴ በኃላ
            </li>
          </ul>
        </div>
     </div>
    </div>
</div>

<div class="services">
  <div class="fb-header service-header">
    <p class="fb-header-text "> <b i18n>SERVICES</b></p>
    <div class="line"></div>
  </div>
  <div class="service-container">
     <div class="service-list">
      <h3 i18n>የዘውትር <br> Daily Services</h3>
      <div class="service-details">
         <div class="service-details-list two-fifty-width-pixel">
           <ul>
             <li i18n>
              ጸሎተ ኪዳን(Morning Prayer) <br>
              <b>Time :</b> ከለሊቱ 5 AM ጀምሮ
             </li>
             <li i18n>
              የሕሙማን ፣ የቄዴር ፣ እና <br>የንስሐ ጥምቀት እገልግሎት <br>
              Emersion of Holy Water <br>and anointing of blessed oils <br>
              <b>Time :</b> 7:00AM-9:30AM፣<br> እሁድ ከቅዳሴ በኋላ <br>
              <b>Daily :</b> 7:00AM-9:30AM
             </li>
           </ul>
         </div>
      </div>
     </div>
     <div class="service-list">
      <h3 i18n>ሳምንታዊ <br> Weekly Services</h3>
      <div class="service-details">
         <div class="service-details-list">
          <ul>
            <li i18n>
             የዘውትር እሁድ መርሐ ግብር<br>
             <b>Time :</b> ከለሊቱ 5 ሰዓት እስከ 10:30<br>
            </li>
            <li i18n>
              Sunday Service <br>
              <b>Time :</b> 5:00AM to 10:30AM <br>
              ጸሎተ ኪዳን (Morning Prayer) <br>
              ቅዳሴ (Mass) <br>
              መዝሙር (Sacred Songs) <br>
              ትምህርት (homily) <br>
            </li>
          </ul>
         </div>
      </div>  
    </div>
    <div class="service-list">
      <h3 i18n>ወርሀዊ <br> Monthly Services</h3>
      <div class="service-details">
        <div class="service-details-list two-fifty-width-pixel margin-left-fifty-pixel">
          <ul>
            <li i18n>
              የቅዱስ ገብርኤል ወርሀዊ በዓል <br> በየወሩ በ19 <br>
              Saint Gabriel Commemoration <br>
              <b>Time :</b> Every month on 14th(E.C)
            </li>
            <li i18n>
              የቅዱስ ዮሐንስ ወርሀዊ በዓል <br> 
              Ken: በየወሩ በ30/
              <br> Saint John the Baptist Commemoration Day<br>
              <b>Date :</b> Every month on 14th(E.C)
            </li>
            <li i18n>
              የቅዱስ ሩፋኤል ወርሀዊ በዓል <br> Ken:  በየወሩ በ 14 <br>
              Saint Rufael Commemoration Day <br>
              <b>Date :</b> Monthly on the 14th(E.C)
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="service-list">
      <h3 i18n>አመታዊ <br> Annual Celebration</h3>
      <div class="service-details">
        <div class="service-details-list two-fifty-width-pixel">
          <ul>
            <li i18n>
              መጥምቀ መለኮት ቅዱስ ዮሐንስ <br>ዓመታዊ በዓል <br>
              <b>Time :</b> መስከረም 2 እና ሰኔ 30 <br>
              Saint John the Baptist 
              <br>Annual Commemoration Day
              <br><b>Date :</b>  Sep. 2 & June 30(EC)
            </li>
            <li i18n>
              ልደት(ገና)/Ethiopian Christmas <br>
            </li>
            <li i18n>
              ትንሳዔ/ Ethiopian Easter
            </li>
          </ul>
        </div>
      </div>  
    </div>

  </div>

</div>



<div class="facbook-video">
  <div class="fb-header">
    <p class="fb-header-text" i18n> <b>VISIT OUR FACEBOOK PAGE</b></p>
    <div class="line"></div>
  </div>
  <div class="vid-container">
    <iframe src="https://www.facebook.com/plugins/video.php?height=280&href=https%3A%2F%2Fwww.facebook.com%2Fsaintgabrieleotc%2Fvideos%2F600143114583684%2F&show_text=false&width=560&t=0" 
  width="560" height="280" style="border:none;overflow:hidden"
   scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" allowFullScreen="true"></iframe>
  </div>

  <div class="events">
    <div class="fb-header">
      <p class="fb-header-text" i18n> <b>UPCOMING EVENTS</b></p>
      <div class="line"></div>
    <div class="events-list">
      <div class="event-box">
        <div class="date">
          <span i18n>Nov 20</span>
        </div>
        <p i18n> Fasting for the Lord's birth</p>
      </div>
      <div class="event-box">
        <div class="date">
          <span i18n>Jan 8th</span>
        </div>
        <p i18n> Celebration of Christmas</p>
      </div>
      <div class="event-box">
        <div class="date">
          <span i18n>Feb 12</span>
        </div>
        <p i18n> Lord's baptism Celebration </p>
      </div>
    </div>
  </div> 


  
</div>




</div>

